
export default function setDataLink(
    data, 
    templates, 
    $container, 
    insertOptions,
    language = 'ru') {

    if (!data || !templates || !$container || !$container.length) {
        console.error('Отсутствуют обязательные параметры');
        return null;
    }

    const { position = 'append', afterIndex = null } = insertOptions || {};
    const html = Object.values(templates)
        .map(template => {
            const fileLink = data[template.key];

            if (!fileLink || !fileLink[language]) {
                return '';
            };

            return `
                <li>
                    <a href="${fileLink[language]}" target="_blank" rel="noopener noreferrer">
                        ${template.text}
                    </a>
                </li>
            `;
        })
        .filter(Boolean)
        .join('');

    if (!html) {
        return null;
    }
    
    const insertMethods = {
        prepend: () => $container.prepend(html),
        append: () => $container.append(html),
        after: () => {
            if (afterIndex !== null && $container.children().length > afterIndex) {
                $container.children().eq(afterIndex).after(html);
            } else {
                $container.append(html);
            }
        }
    };

    const insert = insertMethods[position] || insertMethods.append;
    insert();
}


// WEBPACK FOOTER //
// ./_layout/js/setDataLink.js